import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Select } from '../Select';

const meta: Meta<typeof Select> = {
  title: 'Components/Select',
  component: Select,
};

export default meta;
type Story = StoryObj<typeof Select>;

function SelectStory(props: Partial<React.ComponentProps<typeof Select>>) {
  const [value, setValue] = React.useState('');

  return <Select {...props} onChange={value => setValue(value)} value={value} />;
}

export const Default: Story = {
  render: SelectStory,
  args: {
    label: 'Select an option',
    options: [
      { label: 'Option 1', value: 'option1' },
      { label: 'Option 2', value: 'option2' },
      { label: 'Option 3', value: 'option3' },
    ],
  },
};

export const Multiple: Story = {
  render: SelectStory,
  args: {
    label: 'Select an option',
    options: [
      { label: 'Option 1', value: 'option1' },
      { label: 'Option 2', value: 'option2' },
      { label: 'Option 3', value: 'option3' },
    ],
    isMulti: true,
  },
};

export const Status: Story = {
  render: SelectStory,
  args: {
    label: 'Select an option',
    options: [
      { label: 'Option 1', value: 'option1' },
      { label: 'Option 2', value: 'option2' },
      { label: 'Option 3', value: 'option3' },
    ],
  },
};
